import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useToast
} from "@chakra-ui/react";
import { sendReport } from "@lubbezposrednio-frontend/core/src/api";
import { FC, useState } from "react";
import { Model } from "@lubbezposrednio-frontend/core";

// model jest opcjonalny — używany tylko do generycznego toastu błędu (fallback poniżej).
type ReportPopupProps = { onClose: () => void; Id: string; reportableType: string; model?: Model };

// Odmiana rzeczownika wg typu zgłaszanego obiektu (biernik do tytułu, narzędnik do opisu).
const NOUNS: Record<string, { acc: string; ins: string }> = {
  voting: { acc: "głosowanie", ins: "głosowaniem" },
  post: { acc: "post", ins: "postem" },
  portal_post: { acc: "post", ins: "postem" },
  comment: { acc: "komentarz", ins: "komentarzem" },
  user: { acc: "konto", ins: "kontem" }
};

// Zgłoszenie tylko dla zalogowanych — e-mail bierze backend z konta. Modal zamiast inline (web).
const ReportPopup: FC<ReportPopupProps> = ({ onClose, Id, reportableType, model }) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const toast = useToast();
  const noun = NOUNS[reportableType] ?? NOUNS.voting;
  const fail = () => (model ? model.showGenericErrorToast(toast) : toast({ status: "error", isClosable: true, title: "Coś poszło nie tak. Spróbuj ponownie." }));

  const handleSubmit = async () => {
    const trimmed = reason.trim();
    if (trimmed.length < 5 || trimmed.length > 255) {
      toast({ status: "error", isClosable: true, title: "Podaj powód zgłoszenia (od 5 do 255 znaków)" });
      return;
    }
    setSubmitting(true);
    try {
      const response = await sendReport(Id, trimmed, reportableType);
      if (response?.status === 200) {
        toast({ status: "success", isClosable: true, title: "Dziękujemy — zgłoszenie zostało wysłane" });
        onClose();
      } else {
        fail();
      }
    } catch (error) {
      fail();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="18px" mx="16px">
        <ModalHeader color="primary" fontWeight="800">
          Zgłoś {noun.acc}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel fontSize="14px" color="gray.600" fontWeight="600">
              Powód zgłoszenia
            </FormLabel>
            <Textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder={`Opisz, co jest nie tak z tym ${noun.ins}…`}
              borderRadius="12px"
              rows={5}
              autoFocus
            />
          </FormControl>
          <Text fontSize="12px" color="gray.400" mt="10px">
            Zgłoszenie wyślemy z Twojego konta — nie musisz podawać adresu e-mail.
          </Text>
        </ModalBody>
        <ModalFooter gap="10px">
          <Button variant="ghost" onClick={onClose} borderRadius="12px" fontWeight="600" isDisabled={submitting}>
            Anuluj
          </Button>
          <Button onClick={handleSubmit} isLoading={submitting} bg="accent" color="white" borderRadius="12px" fontWeight="700" _hover={{ bg: "#c41a3a" }}>
            Wyślij zgłoszenie
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReportPopup;
